<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import vue2Dropzone from "vue2-dropzone";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import researchAPI from "@/services/standards/research/researchAPI";
import Swal from "sweetalert2";
import { required, maxValue, minValue, } from "vuelidate/lib/validators";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.2.2 Investigación de incidentes, accidentes de trabajo y enfermedades laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    vueDropzone: vue2Dropzone,
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title:
        "3.2.2 Investigación de incidentes, accidentes de trabajo y enfermedades laborales",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.2.2 Investigación de incidentes, accidentes de trabajo y enfermedades laborales",
          active: true,
        },
      ],

      lista: [],
      file: null,
      loading: true,
      typeEvent: [],
      lesion: [],
      agente: [],
      parteAfectada: [],

      submitted: false,

      item: null,

      itemData: null,
      listado: null,
      investigation: {
        causes: null,
        preventive_actions: null,
        corrective_actions: null,
        accident_reports_id: this.$route.params.id,
        capacity_days: null,
        busy_days: null,
        close_investigation: null,
        file: null,
      },
      inves: null,
      accident: {
        accident_report_types_id: null,
        report_subtypes_id: null,
        report_date: null,
        hour: null,
        description: null,
        improvement_plan: null,
        arl_report_date: null,
        employee_id: null,
      },
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],
    };
  },
  validations: {
    investigation: {
      causes: {
        required,
      },
      preventive_actions: {
        required,
      },
      corrective_actions: {
        required,
      },
      capacity_days: {
        minValue: minValue(0),
        maxValue: maxValue(365),
        required,
      },
      busy_days: {
        minValue: minValue(0),
        maxValue: maxValue(6000),
        required,
      },
    },
  },
  methods: {
    getAccidentReport() {
      researchAPI
        .getAccidentReport(this.$route.params.id)
        .then((response) => {
          const reports = response && response.Accident_investigation
            ? response.Accident_investigation.data
            : null;
          if (!reports || reports.length === 0) {
            this.investigation.accident_reports_id = this.$route.params.id;
            return;
          }
          const report = reports[0];
          this.inves = report;
          const images = report.imagen_investigations || [];
          const lastImage = images.length > 0 ? images[images.length - 1] : null;
          this.investigation = {
            causes: report.causes,
            preventive_actions: report.preventive_actions,
            corrective_actions: report.corrective_actions,
            accident_reports_id: report.accident_rpt_id,
            capacity_days: report.capacity_days,
            busy_days: report.busy_days,
            close_investigation: report.close_investigation,
            file: lastImage ? lastImage.file : null,
          };
          this.listado = images;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSubType() {
      accidentAPI
        .getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident;
          this.subtype = typeAccident[0].report_subtype;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTypeEvent() {
      accidentAPI
        .getTypeEvent()
        .then((response) => {
          this.typeEvent = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gettypeOfInjury() {
      accidentAPI
        .gettypeOfInjury()
        .then((response) => {
          this.lesion = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidentAgent() {
      accidentAPI
        .getAccidentAgent()
        .then((response) => {
          this.agente = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInjuredPartBody() {
      accidentAPI
        .getInjuredPartBody()
        .then((response) => {
          this.parteAfectada = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      const response = await this.uploadDocument();
      if (!response) {
        this.loading = false;
        Swal.fire({
          title: "Error!",
          text: "¡No se ha podido actualizar!",
          icon: "warning",
          type: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        return;
      }
      const payload = {
        causes: this.investigation.causes,
        preventive_actions: this.investigation.preventive_actions,
        corrective_actions: this.investigation.corrective_actions,
        accident_reports_id: this.investigation.accident_reports_id || this.$route.params.id,
        capacity_days: this.investigation.capacity_days,
        busy_days: this.investigation.busy_days,
        close_investigation: this.investigation.close_investigation,
        file: this.investigation.file,
      };
      const apiCall = this.inves
        ? researchAPI.updateAccident(this.inves.id, payload)
        : researchAPI.save(payload);
      const successText = this.inves
        ? "Informacion actualizada con éxito!"
        : "Investigación creada con éxito!";
      apiCall
        .then(() => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 33,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then(() => {
              setTimeout(() => {
                Swal.fire({
                  title: "Éxito!",
                  text: successText,
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.$router.go(-1);
              }, 2000);
            })
            .catch((error) => {
              this.loading = false;
              Swal.fire({
                title: "Error",
                text: "¡No se ha podido registrar!",
                icon: "error",
                type: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          Swal.fire({
            title: "Error",
            text: "¡No se ha podido guardar la investigación!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        });
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItemData() {
      ItemAPI.getItems(33)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page;
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 33)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.investigation.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.2.2/${this.accident.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.2.2/${this.accident.employee_id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.investigation.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getAccident() {
      accidentAPI
        .getAccident(this.$route.params.id)
        .then((response) => {
          this.accident = {
            accident_report_types_id: response.accident_report_types_id,
            report_subtypes_id: response.accident_report_types_id,
            report_date: response.report_date,
            hour: response.hour,
            description: response.description,
            improvement_plan: response.improvement_plan,
            arl_report_date: response.arl_report_date,
            file: response.file,
            employee_id: response.employee_id,
            accident_agents_id: response.accident_agents_id,
            injured_part_bodies_id: response.injured_part_bodies_id,
            type_of_injuries_id: response.type_of_injuries_id,
            event_types_id: response.event_types_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getAccident();
    this.getUsers();
    this.getItems();
    this.getItemData();
    this.getAccidentReport();
    this.getSubType();
    this.getTypeEvent();
    this.gettypeOfInjury();
    this.getAccidentAgent();
    this.getInjuredPartBody();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      El responsable de implementación, en compañía del copasst
                      debe registrar y luego proceder con la investigación de
                      los accidentes de trabajo.
                    </p>
                  </CheckModal>
                </div>
              </div>

              <div class="form-row pt-3">
                <b-form-group label-for="number" class="col-md-12 d-flex justify-content-end"
                  label="Cerrar investigación">
                  <input type="checkbox" style="color: #666" class="mr-sm-2 mb-sm-0 ml-3" label="accidente" value="SI"
                    v-model="investigation.close_investigation" />
                </b-form-group>

                <b-form-group class="col-md-6" label="Colaborador" label-for="employee">
                  <select disabled id="employee_id" class="form-control" v-model="accident.employee_id">
                    <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                      {{ item.full_name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>

                <b-form-group label="Tipo" label-for="tipo" inline class="col-sm-4 pl-4">
                  <label class="mr-2"> Accidente </label>
                  <input disabled type="radio" style="color: #666" :value="1"
                    v-model="accident.accident_report_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                  <label class="mr-2 pl-sm-2 pl-md-0"> Incidente </label>
                  <input disabled type="radio" :value="2" v-model="accident.accident_report_types_id"
                    class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                  <label class="mr-2 pl-sm-2 pl-md-0">
                    Enfermedad laboral
                  </label>
                  <input disabled type="radio" :value="3" v-model="accident.accident_report_types_id"
                    class="mb-2 mr-sm-2 mb-sm-0" label="enfermedad" />
                </b-form-group>
              </div>

              <div class="form-row mt-2 ml-4">
                <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                  class="col-sm-2 mr-4" label="Tipo de accidente">
                  <select id="type" disabled class="form-control" v-model="accident.report_subtypes_id">
                    <b-form-select-option v-for="tipo1 in subtype" :key="tipo1.id" :value="tipo1.id">
                      {{ tipo1.name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>

                <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                  class="col-sm-2 mr-4" label="Tipo de evento">
                  <select id="type" disabled class="form-control" v-model="accident.event_types_id">
                    <b-form-select-option v-for="tipo2 in typeEvent" :key="tipo2.id" :value="tipo2.id">
                      {{ tipo2.name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
                <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                  class="col-sm-2 mr-4" label="Tipo de lesión">
                  <select id="type" disabled class="form-control" v-model="accident.type_of_injuries_id">
                    <b-form-select-option v-for="tipo3 in lesion" :key="tipo3.id" :value="tipo3.id">
                      {{ tipo3.name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
                <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                  class="col-sm-2 mr-4" label="Agente del accidente">
                  <select id="type" disabled class="form-control" v-model="accident.accident_agents_id">
                    <b-form-select-option v-for="tipo4 in agente" :key="tipo4.id" :value="tipo4.id">
                      {{ tipo4.name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
                <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type"
                  class="col-sm-2 mr-4" label="Parte del cuerpo afectada">
                  <select id="type" disabled class="form-control" v-model="accident.injured_part_bodies_id">
                    <b-form-select-option v-for="tipo5 in parteAfectada" :key="tipo5.id" :value="tipo5.id">
                      {{ tipo5.name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
                <b-form-group v-else id="report_type" label-for="type" class="col-sm-2">
                </b-form-group>
              </div>

              <div class="form-row">
                <b-form-group class="col-md-6" label="Fecha" label-for="input-sm">
                  <b-form-input disabled v-model="accident.report_date" type="date" id="input-sm"
                    placeholder="fecha"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6" label="Fecha de reporte a la arl" label-for="input-sm">
                  <b-form-input disabled v-model="accident.arl_report_date" type="date" id="input-sm"
                    placeholder="fecha"></b-form-input>
                </b-form-group>
              </div>

              <div class="form-row">
                <b-form-group class="col-md-12" label="Descripción de la situación" label-for="input-sm">
                  <b-form-textarea disabled id="textarea" v-model="accident.description" rows="4"></b-form-textarea>
                </b-form-group>
              </div>
              <div class="form-row">
                <b-form-group class="col-md-12" label="Plan de mejora" label-for="input-sm">
                  <b-form-textarea disabled id="textarea" v-model="accident.improvement_plan"
                    rows="4"></b-form-textarea>
                </b-form-group>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div>
                  <div class="form-row">
                    <b-form-group label-for="number" class="col-md-6" label="Días de incapacidad">
                      <b-form-input type="number" id="date_exam" :class="{
                        'is-invalid':
                          $v.investigation.capacity_days.$error && submitted,
                      }" v-model="investigation.capacity_days">
                      </b-form-input>
                      <div v-if="submitted && $v.investigation.capacity_days.$error">
                        <small v-if="!$v.investigation.capacity_days.minValue" class="text-danger">
                          <b>Tiene que ser un valor numérico entre 0 y 365</b>
                        </small>
                        <small v-else-if="!$v.investigation.capacity_days.maxValue" class="text-danger">
                          <b>Tiene que ser un valor numérico entre 0 y 365</b>
                        </small>
                      </div>
                    </b-form-group>
                    <b-form-group label-for="number" class="col-md-6" label="Días cargados">
                      <b-form-input type="number" id="date_exam" :class="{
                        'is-invalid':
                          $v.investigation.busy_days.$error && submitted,
                      }" v-model="investigation.busy_days">
                      </b-form-input>
                      <div v-if="submitted && $v.investigation.busy_days.$error">
                        <small v-if="!$v.investigation.busy_days.minValue" class="text-danger">
                          <b>Tiene que ser un valor numérico entre 0 y 6000</b>
                        </small>
                        <small v-else-if="!$v.investigation.busy_days.maxValue" class="text-danger">
                          <b>Tiene que ser un valor numérico entre 0 y 6000</b>
                        </small>
                      </div>
                    </b-form-group>
                  </div>

                  <div class="form-row">
                    <b-form-group class="col-md-12" label="Causas" label-for="input-sm">
                      <b-form-textarea id="textarea" v-model="investigation.causes" rows="4">
                      </b-form-textarea>
                    </b-form-group>
                  </div>

                  <div class="form-row">
                    <b-form-group class="col-md-12" label="Acciones preventivas" label-for="input-sm">
                      <b-form-textarea id="textarea" v-model="investigation.preventive_actions" rows="4">
                      </b-form-textarea>
                    </b-form-group>
                  </div>

                  <div class="form-row">
                    <b-form-group class="col-md-12" label="Acciones correctivas" label-for="input-sm">
                      <b-form-textarea id="textarea" v-model="investigation.corrective_actions" rows="4">
                      </b-form-textarea>
                    </b-form-group>
                  </div>

                  <b-form-file class="mb-4" type="file" id="file" ref="file" name="file" browse-text="Buscar"
                    :placeholder="investigation.file
                      ? getFile(investigation.file)
                      : `Selecciona un archivo...`
                      " drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                  </b-form-file>
                </div>

                <div class="form-group text-right m-b-0">
                  <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
